import Sprite from "../object-graphics/Sprite";
import PixelNumber from "../object-graphics/PixelNumber";
import styles from "./ClockCount.module.css";
import { TILES } from "../../helpers/tiles";

export default function ClockCount({ level }) {
  const timeLeftNumber = Math.floor(level.secondsLeft);
  return (
    <div className={styles.clockCount}>
      <Sprite frameCoord={TILES.CLOCK} />
      <PixelNumber number={timeLeftNumber} />
    </div>
  );
}
